module.exports = __webpack_public_path__ + "static/img/Drafts.e3c94889.svg";